import { getRequest, postRequest } from '../core/apiRequests';

export const getAppointments = async ({ query, loadingStatusOff = true, axiosConfig = {} }) => {
  const reqObj = {
    params: ['today', 'appointments'],
    loadingStatusOff,
    axiosConfig,
    query,
  };

  return getRequest(reqObj);
};

export const completeAppointments = async (appointmentIds, loadingStatusOff = false) => {
  const reqObj = {
    params: ['today', 'appointments', 'complete'],
    method: 'POST',
    data: { appointmentIds },
    loadingStatusOff,
  };

  return postRequest(reqObj);
};

export const assignAssociateToAppointments = async (appointmentIds, associateId, loadingStatusOff = false) => {
  const reqObj = {
    params: ['today', 'appointments', 'assign'],
    method: 'POST',
    data: { appointmentIds, associateId },
    loadingStatusOff,
  };

  return postRequest(reqObj);
};
